<template>
  <div class="create-new-sku">
    <div class="breadcrumb" style="background: #fff">创建SKU组</div>
    <div class="third-title">SKU组属性</div>
    <div class="order-detail-basic" style="padding-top: 0;">
      <el-form :model="addSkuGroupStepOneVo.skuGroups[0]" label-width="150px" ref="formRef" style="margin:40px;" :rules="formRules">
        <el-form-item label="SKU组名称：" prop="skuGroupName">
          <el-input v-model="addSkuGroupStepOneVo.skuGroups[0].skuGroupName" placeholder=""></el-input>
          <el-button round type="primary" @click="createSkuName">生成SKU组名称</el-button>
        </el-form-item>
        <el-form-item v-for="item in spuDictList" :key="item.id" :label="item.propKey">
          <el-select v-model="choiceDice[item.id]" value-key="id" @change='$forceUpdate()' placeholder="请选择">
            <el-option v-for="val in item.options" :key="val.id" :label="val.propVal" :value="val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SKU组图片：" prop="skuGroupImage">
          <el-button round type="primary" @click="uploadImg()">上传图片</el-button>
          <div style="margin-top:20px;">
            <img style="max-width:200px" :src="addSkuGroupStepOneVo.skuGroups[0].skuGroupImage" alt="">
          </div>
          <el-upload class="avatar-uploader upload_warp_left" id="upload-img" style="display:none" action="#" :http-request="fileSize">
          </el-upload>
        </el-form-item>
        <el-form-item label="平台价格：" v-if="$route.query.spuProperty === 'NORMAL'" prop="price">
          <el-input v-model="addSkuGroupStepOneVo.skuGroups[0].price" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="在线支付价格：" v-if="$route.query.spuProperty === 'NORMAL'" prop="onlineSalePrice">
          <el-input v-model="addSkuGroupStepOneVo.skuGroups[0].onlineSalePrice" placeholder="请输入内容"></el-input>
        </el-form-item>
        <!-- 新加的 -->
        <el-form-item label="初创平台价格：" v-if="$route.query.spuProperty === 'NORMAL' && $route.query.startupsSpu" prop="startupsSamplePrice">
          <el-input v-model="addSkuGroupStepOneVo.skuGroups[0].startupsSamplePrice" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="最低终端价格：" v-if="$route.query.spuProperty === 'NORMAL'" prop="salePrice">
          <el-input v-model="addSkuGroupStepOneVo.skuGroups[0].salePrice" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="通货编码：" v-if="$route.query.spuProperty === 'NORMAL'" prop="sampleBarCode">
          <el-input v-model="addSkuGroupStepOneVo.skuGroups[0].sampleBarCode" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="goOn">{{ $route.query.spuProperty === 'NORMAL' ? "确定" : '下一步' }}</el-button>
    </div>
  </div>
</template>
<script>
import { spuGet, dictQueryByPid, skuGroupAdd, skuGroupAddCurrency, spuHasWhitePage } from '@/api/pms'
import { storeTypeGetStoreTypeList } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'CreateNewSKu',
  data () {
    return {
      formRules: {
        price: [
          { required: true, message: '请填写平台价格', trigger: 'blur' }
        ],
        onlineSalePrice: [
          { required: true, message: '请填写在线支付价格', trigger: 'blur' }
        ],
        startupsSamplePrice: [
          { required: true, message: '请填写初创平台价格', trigger: 'blur' }
        ],
        salePrice: [
          { required: true, message: '请填写最低终端价格', trigger: 'blur' }
        ],
        sampleBarCode: [
          { required: true, message: '请填写通货编码', trigger: 'blur' }
        ]
      },
      awsSdk: null,
      addSkuGroupStepOneVo: {
        skuGroups: [
          {
            dictIdSet: '',
            dictSet: '',
            skuGroupImage: '',
            skuGroupName: '',
            price: '',
            salePrice: '',
            sampleBarCode: ''
          }
        ],
        spuId: this.$route.query.id
      },
      choiceDice: {
      },
      choice: '',
      spuDictList: [],
      dickKey: []
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getSpuMsg()
  },
  methods: {
    createSkuName () {
      let name = this.$route.query.spuName
      Object.keys(this.choiceDice).forEach(key => {
        if (this.choiceDice[key]) {
          name += '-' + this.choiceDice[key].propVal
        }
      })
      //
      this.addSkuGroupStepOneVo.skuGroups[0].skuGroupName = name
    },
    // 下一步
    goOn () {
      if (this.addSkuGroupStepOneVo.skuGroups[0].skuGroupName === '') {
        this.$message.error('未输入sku组名称')
        return
      }
      let dictIdSet = ''
      let dictSet = ''
      for (let item in this.choiceDice) {
        if (this.choiceDice[item] === '') {
          this.$message.error('有属性未选择属性值')
          return
        }
        dictIdSet += item + ':' + this.choiceDice[item].id + ';'
        dictSet += this.choiceDice[item].propKey + ':' + this.choiceDice[item].propVal + ';'
      }
      this.addSkuGroupStepOneVo.skuGroups[0].dictIdSet = dictIdSet
      this.addSkuGroupStepOneVo.skuGroups[0].dictSet = dictSet
      if (this.addSkuGroupStepOneVo.skuGroups[0].skuGroupImage === '') {
        this.$message.error('未上传图片')
        return
      }
      if (this.$route.query.spuProperty === 'NORMAL') {
        this.$refs.formRef.validate((valid) => {
          if (!valid) {
            return
          }
          skuGroupAddCurrency(this.addSkuGroupStepOneVo).then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
              this.$router.go(-1)
            }
          })
        })
      } else {
        skuGroupAdd(this.addSkuGroupStepOneVo).then(res => {
          if (res.data.success) {
            let data = JSON.stringify(res.data.data)
            spuHasWhitePage(this.$route.query.id).then(res => {
              if (res.data.success) {
                this.$router.push({ path: '/createnewsku2', query: { detail: data, dict: JSON.stringify(this.dickKey), hasWhitePage: res.data.data, startupsSpu: this.$route.query.startupsSpu, showPoint: this.$route.query.showPoint } })
              }
            })
          }
        })
      }
    },
    // 选择属性
    selectDict () {
      this.$forceUpdate()
    },
    // 获得产品详情
    getSpuMsg () {
      spuGet(this.$route.query.id).then(res => {
        if (res.data.success) {
          if (res.data.data.isSingleSkuGroup && (res.data.data.skuGroupList.length >= 1)) {
            this.$message.error('该产品为单sku组产品，并且已有sku组')
            this.$router.go(-1)
            return
          }

          let list = res.data.data.spuDictList
          // 属性详情
          list.forEach((item, index) => {
            this.dickKey.push({
              id: item.id,
              key: item.propKey
            })
            this.choiceDice[item.id] = ''
            dictQueryByPid(item.id).then(res2 => {
              item.options = []
              if (res2.data.success) {
                item.options = res2.data.data
                if (index + 1 === list.length) {
                  this.spuDictList = list
                }
              }
              this.$forceUpdate()
            })
          })
        }
      })
    },
    fileSize (data) {
      let file = data.file
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          // 婚纱或者积分产品不验证 尺寸 
          if (_this.$route.query.categoryId == 10 || _this.$route.query.categoryId == 13) {
            _this.httpRequest(file)
          } else {
            if (width === height) {
              _this.httpRequest(file)
            } else {
              _this.$message.error('图片长宽不相同')
            }
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传图片
    httpRequest (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.addSkuGroupStepOneVo.skuGroups[0].skuGroupImage = res
        this.$forceUpdate()
      })
    },
    // 点击上传图片
    uploadImg () {
      document.querySelector('.el-upload__input').click()
    }
  }
}
</script>
<style scoped lang="less">
@import "./styles.less";
@deep: ~">>>";

.asdasd {
  display: inline-block;
  box-sizing: border-box;
  padding: 0 0 0 10px;
  width: 80px;
  height: 30px;
  background: rgba(170, 170, 170, 1);
  color: #fff;
  position: relative;
  margin-right: 10px;

  .x {
    position: absolute;
    top: 8px;
    right: 5px;
  }
}

.imgbox {
  // width: 150px;
  height: 150px;

  p {
    height: 100%;
    text-align: center;
    line-height: 150px;
  }

  .qqqqqq {
    width: 100px;
    height: 100px;
    margin: 15px auto;

    img {
      max-width: 100%;
      max-height: 100%;
      display: block;
      margin: auto;
    }
  }

  span {
    display: block;
  }
}
</style>
